var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModalComponent } from "app/views/modal/base_modal.component";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SupportService } from "../support.service";
import { ModalSpreaderService } from "./modal_spreader_service";
import { AbstractControl, FormControl, ValidatorFn } from "@angular/forms";
import * as moment from 'moment-timezone';
import { environment } from 'environments/environment';
import { BaseFormGroup } from "../../../models/form";
import { FormControlValidators } from "../../../models/validators/validator";
var BaseSupportModalComponent = /** @class */ (function (_super) {
    __extends(BaseSupportModalComponent, _super);
    function BaseSupportModalComponent(activeModal, supportService, spreader) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.supportService = supportService;
        _this.spreader = spreader;
        _this._comment = (!environment.SEXTANT && !environment.PRODUCTION) ? 'Тестирование админки' : '';
        _this.isBtnOkActive = true;
        _this.errors = [];
        _this.form = new BaseFormGroup({});
        _this.CustomValidators = {
            dateFormat: function (format) {
                return function (control) {
                    if (!control.value) {
                        return null;
                    }
                    var isInvalid = !(moment(control.value, format, true).isValid());
                    return isInvalid ? { 'dateFormat': { 'requiredFormat': format, 'actualFormat': control.value } } : null;
                };
            },
            dateNotBeforeToday: function (format) {
                return function (control) {
                    if (!control.value) {
                        return null;
                    }
                    var dt = moment(control.value, format, true);
                    if (dt.isValid()) {
                        var isInvalid = dt.endOf('day').isBefore();
                        return isInvalid ? { 'dateNotBeforeToday': { 'minDate': moment().format(format), 'actualDate': dt.format(format) } } : null;
                    }
                    return null;
                };
            },
        };
        //spreader - фиксер кривого наследования
        if (_this.spreader.child == null) {
            _this.spreader.child = _this;
        }
        _this.spreader.base = _this;
        if (_this.constructor.name == 'SetDivlyIdModalComponent') {
        }
        return _this;
    }
    Object.defineProperty(BaseSupportModalComponent.prototype, "comment", {
        get: function () {
            return this.spreader.base._comment;
        },
        set: function (value) {
            this.spreader.base._comment = value;
        },
        enumerable: true,
        configurable: true
    });
    BaseSupportModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form.addControl('comment', new FormControl(this.comment, [
            FormControlValidators.required(),
            FormControlValidators.minLength(10),
        ]));
        this.form.statusChanges.subscribe(function (status) {
            if (status === 'VALID') {
                _this.errors = [];
            }
        });
    };
    BaseSupportModalComponent.prototype.validate = function () {
        this.errors = [];
        if (this.form.status === 'VALID') {
            return true;
        }
        for (var _i = 0, _a = Object.keys(this.form.controls); _i < _a.length; _i++) {
            var keyC = _a[_i];
            var errors = this.form.controls[keyC].errors;
            if (errors != null) {
                for (var _b = 0, _c = Object.keys(errors); _b < _c.length; _b++) {
                    var keyE = _c[_b];
                    var error = errors[keyE];
                    if (error.message) {
                        this.errors.push(error.message);
                    }
                    else {
                        this.errors.push(keyE);
                    }
                }
            }
        }
        return false;
    };
    BaseSupportModalComponent.prototype.ok = function () {
        if (this.validate()) {
            this.onOk.emit();
        }
    };
    BaseSupportModalComponent.prototype.execute = function () {
        this.activeModal.close('OK');
    };
    BaseSupportModalComponent.prototype.getCustomValidator = function (name, f) {
        return function (control) {
            return f(name, control);
        };
    };
    BaseSupportModalComponent.prototype.getStandartValidator = function (name, validator, message) {
        return function (control) {
            var isInvalid = validator(control);
            var err = {};
            err[name] = { value: control.value, message: message };
            return isInvalid != null ? err : null;
        };
    };
    return BaseSupportModalComponent;
}(BaseModalComponent));
export { BaseSupportModalComponent };
